import React, { useEffect } from 'react'
import { Views } from '../../views'
import { connect, useDispatch } from 'react-redux'
import { get, isEmpty } from 'lodash'
import { GET_RESERVATION, GET_CONFERENCE, SET_CONFERENCE } from '../../redux//actions/type'
import { getDaysCalendar, isFetchReserve } from '../../helpers'
import useGoogleAnalytics from '../../libs/googleAnalytics'

const Landing = ({ keycloak, authenticated, language }) => {
    useGoogleAnalytics();
    const { Landing } = Views
    const dispatch = useDispatch()

    useEffect(() => {
        if (isFetchReserve()) {
            dispatch({
                type: GET_RESERVATION
            })
        }
    }, [dispatch])

    useEffect(() => {
        if (!isEmpty(keycloak) && isFetchReserve()) {
            if (authenticated) {
                const { firstDay, lastDay } = getDaysCalendar(new Date())
                dispatch({
                    type: GET_CONFERENCE,
                    payload: {
                        startDate: firstDay,
                        endDate: lastDay,
                    }
                })
            } else {
                dispatch({
                    type: SET_CONFERENCE,
                    payload: {
                        statusData: 'success'
                    }
                })
            }
        }
    }, [dispatch, keycloak, authenticated])


    useEffect(() => {
        if (!isEmpty(keycloak) && authenticated && isFetchReserve()) {
            //fetch every 1 min
            setTimeout(() => {
                const { firstDay, lastDay } = getDaysCalendar(new Date())
                dispatch({
                    type: GET_CONFERENCE,
                    payload: {
                        startDate: firstDay,
                        endDate: lastDay,
                    }
                })
                dispatch({
                    type: GET_RESERVATION
                })
            }, 1000 * 60);
        }
    }, [dispatch, keycloak, authenticated])

    return (
        <Landing keycloak={keycloak} authenticated={authenticated} language={language} />
    )
}

const mapStateToProps = state => ({
    keycloak: get(state, 'keycloak', ''),
    authenticated: get(state, 'keycloak.authenticated', false),
    language: get(state, 'language', 'th')
})

export default connect(mapStateToProps)(Landing)